export * from './skyscraper8.component';